export default function initHeaderLangSwitcher() {
	const languageDropdowns = document.querySelectorAll(".header__lang");

	document.addEventListener("click", (event) => {
		languageDropdowns.forEach((dropdown) => {
			if (!dropdown.contains(event.target)) {
				dropdown.removeAttribute("open");
			}
		});
	});

	document.addEventListener("keydown", (event) => {
		if (event.key !== "Escape") {
			return;
		}

		languageDropdowns.forEach((dropdown) => {
			dropdown.removeAttribute("open");
		});
	});
}
